$(document).ready(function () {
  // Hero Home
  setTimeout(function () {
    $("#main-image").addClass("animation-background");
    $("#overlay-image-container").addClass("animation-logo-visible");
  }, 1200);

  // Logo Carousel
  var logoCarousel = document.querySelector(".logoCarousel");
  if (logoCarousel) {
    var flkty = new Flickity(logoCarousel, {
      cellAlign: "center",
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      draggable: true,
    });
  }

  // Bilder Carousel
  var bilderCarousel = document.querySelector(".bilderCarousel");
  if (bilderCarousel) {
    var flkty = new Flickity(bilderCarousel, {
      cellAlign: "center",
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      draggable: true,
    });
  }

  // Navigation
  $(".hamburger").on("click", function () {
    if ($(".mainmenu").hasClass("hidden")) {
      $(".hamburger").addClass("is-active");
      $(".overlay-mobilenav").addClass("overlay-show");
      $(".mainmenu").removeClass("hidden").show();
      $(".primary__menu > li").each(function (index) {
        $(this)
          .delay(index * 100)
          .queue(function (next) {
            $(this).addClass("show");
            next();
          });
      });
    } else {
      $(".hamburger").removeClass("is-active");
      $(".overlay-mobilenav").removeClass("overlay-show");
      $(".primary__menu > li").each(function (index) {
        $(this)
          .delay(index * 100)
          .queue(function (next) {
            $(this).removeClass("show");
            next();
          });
      });
      setTimeout(
        function () {
          $(".mainmenu").addClass("hidden").hide();
        },
        $(".primary__menu > li").length * 100,
      );
    }
  });

  $(".menu-item-has-children > a").on("click", function (event) {
    // Überprüfe, ob auf das Pseudoelement geklickt wurde
    var afterElementWidth = parseInt(window.getComputedStyle(this, "::after").width, 10);
    var clickPosition = event.pageX - $(this).offset().left;
    if (clickPosition > $(this).width() - afterElementWidth) {
      event.preventDefault();
      event.stopPropagation();
      $(".menu-item-has-children").not($(this).parent()).removeClass("open");
      $(this).parent().toggleClass("open");
    }
  });

  $(".menu-item-has-children > ul > li > a").on("click", function (event) {
    $(".primary__menu > li").each(function (index) {
      $(this)
        .delay(index * 100)
        .queue(function (next) {
          $(this).removeClass("show");
          next();
        });
    });
    setTimeout(
      function () {
        $(".overlay-mobilenav").removeClass("overlay-show");
        $(".mainmenu").addClass("hidden").hide();
      },
      $(".primary__menu > li").length * 100,
    );
  });

  // Text Carousel

  var textCarousel = document.querySelector(".textCarousel");
  if (textCarousel) {
    var flkty = new Flickity(textCarousel, {
      cellAlign: "left",
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: 10000,
      pauseAutoPlayOnHover: false,
      draggable: true,
      groupCells: true,
    });
  }

  // Formular Labels
  $(document).on("focus", ".nf-field-element input, .nf-field-element textarea", function () {
    $(this).parent().parent().find(".nf-field-label").addClass("label-selected");
  });

  $(document).on("blur", ".nf-field-element input, .nf-field-element textarea", function () {
    if ($(this).val() === "") {
      $(this).parent().parent().find(".nf-field-label").removeClass("label-selected");
    }
  });
});

// Zahlen Balken
document.addEventListener("scroll", function () {
  if (document.getElementsByClassName("fuellen")[0]) {
    const fueller = document.getElementsByClassName("fuellen");
    for (const fuellen of fueller) {
      const fuellenPos = fuellen.getBoundingClientRect();
      if (fuellenPos.top <= window.innerHeight && fuellenPos.bottom >= 0) {
        fuellen.style.transition = "width 2s ease";
        fuellen.style.width = "100%";
      } else {
        fuellen.style.width = "0%";
        fuellen.style.transition = "width 0s";
      }
    }
  }
});

// Back to Top Button
["load", "scroll"].forEach(function (event) {
  document.addEventListener(event, function () {
    const backToTopButton = document.querySelector(".back-to-top");
    const footer = document.getElementsByTagName("footer")[0].getBoundingClientRect();
    const head = document.getElementsByClassName("back-to-top-anchor")[0];
    if (head) {
      var headHeight = head.offsetHeight;
    } else {
      var headHeight = 0;
    }
    if (footer.y + window.scrollY < window.innerHeight + window.scrollY) {
      backToTopButton.style.position = "relative";
    } else if (window.scrollY < headHeight * 0.5) {
      backToTopButton.style.opacity = "0";
    } else {
      backToTopButton.style.position = "fixed";
      backToTopButton.style.opacity = "1";
    }
  });
});
// Mehr anzeigen bei Beiträgen
document.addEventListener("DOMContentLoaded", function () {
  var postsPerPage = 6;
  var posts = document.querySelectorAll(".beitrag");
  var totalPosts = posts.length;
  var currentPage = 1;
  if (document.getElementById("load-more")) {
    document.getElementById("load-more").addEventListener("click", function (e) {
      e.preventDefault();
      currentPage++;
      var start = (currentPage - 1) * postsPerPage;
      var end = currentPage * postsPerPage;

      for (var i = start; i < end && i < totalPosts; i++) {
        posts[i].classList.remove("hidden");
      }

      if (end >= totalPosts) {
        document.getElementById("load-more").style.display = "none";
      }
    });
  }
});

// cookie banner

$(document).ready(function () {
  (function () {
    "use strict";
    let cookieAlert = document.querySelector(".cookiealert");
    let acceptCookies = document.querySelector(".acceptcookies");
    cookieAlert.offsetHeight;
    if (!manageCookie("acceptCookies")) {
      cookieAlert.classList.add("show");
    }
    acceptCookies.addEventListener("click", function () {
      manageCookie("acceptCookies", true, 60);
      cookieAlert.classList.remove("show");
    });
  })();

  function manageCookie(cname, cvalue, exdays) {
    if (cvalue === undefined) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    } else {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
  }
});
